import { Group, Stack, Text } from '@mantine/core';
import { crmWidgetAmountFormat } from '../shared/presentation';

/** Колонка план/факт за один квартал. */
export function QuarterColumn({
  label,
  plan,
  fact,
}: {
  label: string;
  plan: number;
  fact: number;
}) {
  return (
    <Stack
      gap={2}
      style={{
        flex: 1,
        minWidth: 0,
        backgroundColor: '#ffffff5e',
        padding: '6px 8px',
        borderRadius: 8,
      }}
    >
      <Text size='xs' c='dimmed' ta='right'>
        {label}
      </Text>
      <Group gap='md'>
        <Stack gap={0}>
          <Text size='xs' c='dimmed'>
            План
          </Text>
          <Text size='sm' fw={600}>
            {crmWidgetAmountFormat.format(plan)} ₽
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text size='xs' c='dimmed'>
            Факт
          </Text>
          <Text size='sm' fw={600} c={fact > 0 ? 'green.7' : undefined}>
            {crmWidgetAmountFormat.format(fact)} ₽
          </Text>
        </Stack>
      </Group>
    </Stack>
  );
}
